// import {IconButton, Link, Typography} from "@mui/joy";
import {Grid, IconButton, Link, Typography} from "@mui/material";
import Logo from "@images/AppSymbol.png";
import {useMsal} from "@azure/msal-react";
import React from "react";
import {useNavigate} from "react-router";

export type Types = 'Not Logged' | 'Blocked' | 'Unauthorized'

export const Unauthenticated: React.FC<{ type?: Types }> = ({type}) => {
    const {instance} = useMsal()
    const navigate = useNavigate()
    const handleLogin = async () => {
        await instance.loginRedirect()
    }

    const message = {
        'Not Logged': <>Para acessar, você deve
            <Link pl={'0.5ch'} onClick={handleLogin}>fazer
                login</Link></>,
        'Blocked': <>Sua conta está <Typography color={'error'}>BLOQUEADA!</Typography> Verifique com os
            administradores!</>,
        'Unauthorized': <>Você não tem permissão para acessar esta área!</>
    }[type || 'Not Logged']


    return (
        <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid size={12} alignItems={'center'} justifyContent={'center'}>
                <Typography textAlign={'center'}>Acesso não autorizado!</Typography>
                <Typography textAlign={'center'}>{message}</Typography>
            </Grid>
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <IconButton onClick={() => type == 'Not Logged' && handleLogin() || navigate('/')}>
                    <img src={Logo} height={250} alt={'AegisCloud'}/>
                </IconButton>
            </Grid>
        </Grid>
    )
}